import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IChangeRequestApprove {
  id: number;
  type: string;
  approve: boolean;
  userId: number;
  rejectReason:string;
}

async function approveChangeRequest(data: IChangeRequestApprove): Promise<any> {
  try {
    return (await axiosInstance.post("/ChangeRequest/Approve", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useApproveChangeRequest() {
  return useMutation<any, Error, IChangeRequestApprove>((variables) =>
    approveChangeRequest(variables)
  );
}